/** Asegura tinta legible en SVG VexFlow (glifos Bravura usan <text>, no solo <path>). */
export function applyPrintSvgInk(host: HTMLDivElement, color = '#0a0a0a'): void {
  const svg = host.querySelector('svg');
  if (!svg) return;
  svg.querySelectorAll('text').forEach((el) => {
    el.setAttribute('fill', color);
    el.removeAttribute('stroke');
  });
  svg.querySelectorAll('path[fill="none"], path[fill="transparent"]').forEach((el) => {
    el.setAttribute('stroke', color);
  });
}
